import { render, staticRenderFns } from "./TicketRecord.vue?vue&type=template&id=a48d4bb8&scoped=true"
import script from "./TicketRecord.vue?vue&type=script&lang=js"
export * from "./TicketRecord.vue?vue&type=script&lang=js"
import style0 from "./TicketRecord.vue?vue&type=style&index=0&id=a48d4bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48d4bb8",
  null
  
)

export default component.exports